import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { getSubCategories } from 'common/ducks/categories';

const SubcategoryName = ({ name }) => (<span>{name}</span>);

SubcategoryName.propTypes = {
  name: PropTypes.string.isRequired,
};

const mapStateToProps = (state, { id }) => {
  const { categories } = state;
  const subcategories = getSubCategories(categories);

  return {
    ...subcategories.find(subCat => (subCat.id === id))
  };
};

export default connect(mapStateToProps)(SubcategoryName);



// WEBPACK FOOTER //
// ./common/containers/subcategory_name.js